import React from 'react'
import EmailChangeElement from '../../../components/Login/Modules/EmailChange/EmailChange.jsx'
export const AdvisorEmailChange = () => {
  return <EmailChangeElement />
}
